import { gql } from '@urql/core';
import React from 'react';
import { CommittedToCollegeCardFragment } from '../../../generated/spin-graphql';
import { CollegeIcon } from '../../svg/CollegeIcon';

type Props = {
    player: CommittedToCollegeCardFragment;
};

gql`
    fragment CommittedToCollegeCard on espin_player_profile {
        first_name
        last_name
        committed_to_college
    }
`;

export const CommittedToCollegeCard: React.FC<Props> = ({ player }) => {
    return (
        <div className="committed-to-college-card">
            <CollegeIcon />
            {`${player.first_name} ${player.last_name} has committed to ${player.committed_to_college}.`}
        </div>
    );
};
